export default __webpack_public_path__ + "static/media/Gallery-16.ac65d4c3.jpeg";